export default {"src":"/_next/static/media/check_icon.8cf4ce31.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};